const truffleContract = require('@truffle/contract')
// declare type TimContract = (truffleContract: {}) => any
function toContract(truffleContractJson: {}): any {
  return truffleContract(truffleContractJson);
}
export default toContract